(function variantWatcher() {
  const selectedColorElements = document.querySelectorAll(".selected__variant");

  if (!selectedColorElements || selectedColorElements.length === 0) {
    setTimeout(variantWatcher, 500);
    return;
  }

  function getVariantIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    return variantId ? parseInt(variantId, 10) : null;
  }

  // Capitalize each word
  function capitalizeEachWord(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  // Convert option name to ID format: "Color Size" => "selected__color_size"
  function getSpanIdFromOptionName(name) {
    return `selected__${name.toLowerCase().replace(/\s+/g, "_")}`;
  }

  function updateOptionDisplays(variant) {
    const optionNames = window.ShopifyAnalytics?.meta?.product?.options || [
      "Color",
      "Size",
    ];
    const values = variant.public_title?.split(" / ") || [];

    optionNames.forEach((optionName) => {
      const spanId = getSpanIdFromOptionName(optionName);
      const elArray = document.querySelectorAll("." + spanId);

      if (elArray.length > 0) {
        const index = optionNames.indexOf(optionName);
        let value = values[index] || values[0] || "";
        if (value) {
          elArray.forEach((el) => {
            el.innerHTML = capitalizeEachWord(value);
          });

          // ✅ Check the correct input
          const input = document.querySelector(
            `input[name="${optionName}"][value="${value}"]`
          );
          if (input && !input.checked) {
            input.checked = true;
            // input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        } else {
          elArray.forEach((el) => {
            el.innerHTML = "—";
          });
          console.warn(`No value for "${optionName}" in public_title`);
        }
      }
    });
  }

  function updateFormVariantId(variantId) {
    // find all product forms and update the hidden "id" field
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        console.log("✅ Updated form variant ID:", variantId);
      }
    });
  }
  const sliderTrack = document.querySelector(".product_variants_section");

  let isDragging = false;
  let startX;
  let scrollLeft;

  sliderTrack.addEventListener("mousedown", (e) => {
    isDragging = true;
    sliderTrack.style.cursor = "grabbing";
    startX = e.pageX - sliderTrack.offsetLeft;
    scrollLeft = sliderTrack.scrollLeft;
  });

  sliderTrack.addEventListener("mouseleave", () => {
    isDragging = false;
    sliderTrack.style.cursor = "grab";
  });

  sliderTrack.addEventListener("mouseup", () => {
    isDragging = false;
    sliderTrack.style.cursor = "grab";
  });

  sliderTrack.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - sliderTrack.offsetLeft;
    const walk = (x - startX) * 1; // Adjust multiplier for drag speed
    sliderTrack.scrollLeft = scrollLeft - walk;
  });

  // Keep checking current variant
  setInterval(() => {
    let currentVariantId =
      window.ShopifyAnalytics?.meta?.selectedVariantId || getVariantIdFromURL();
    if (!currentVariantId) return;
    const matchingVariant =
      window.ShopifyAnalytics?.meta?.product?.variants?.find(
        (v) => v.id == currentVariantId
      );
    if (matchingVariant) {
      updateOptionDisplays(matchingVariant);
      updateFormVariantId(matchingVariant.id);
    }
  }, 500);

  // --------------------------------POPUP function (for swatches) ----------------------------------------

  const colorSwatches = document.querySelectorAll(".color__swatch");

  colorSwatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const selectedColorValue = capitalizeEachWord(this.value);
      const product = window.ShopifyAnalytics?.meta?.product;
      const swatchName = this.getAttribute("name");
      document
        .querySelectorAll(`.color__swatch[name="${swatchName}"]`)
        .forEach((s) => {
          s.checked = false; // uncheck all in same group
        });
      this.checked = true;
      if (!product?.variants) return;

      // Find the variant that matches this color
      const matchingVariant = product.variants.find((v) =>
        v.public_title.toLowerCase().includes(selectedColorValue.toLowerCase())
      );

      if (matchingVariant) {
        // ✅ Update ShopifyAnalytics
        window.ShopifyAnalytics.meta.selectedVariantId = matchingVariant.id;

        // ✅ Update URL without reload
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", matchingVariant.id);
        window.history.replaceState({}, "", newUrl);

        // ✅ Update spans (color/size)
        updateOptionDisplays(matchingVariant);
      }

      // ✅ Update the color span text
      const colorSpan = document.getElementById("selected__color");
      if (colorSpan) {
        colorSpan.textContent = selectedColorValue;
      }
    });
  });
})();
// quick-add-modal.js (separate JS file)
document.addEventListener("click", (event) => {
  // Detect click on color or size swatches
  const swatch = event.target.closest(
    ".quick-add-modal .variant-color-card, .quick-add-modal .variant-size-card"
  );
  if (!swatch) return;

  const modal = swatch.closest(".quick-add-modal");
  if (!modal) return;

  const productJSON = modal.querySelector(".variant-json");
  if (!productJSON) return;
  const product = JSON.parse(productJSON.textContent);

  const capitalizeEachWord = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  // Get the input inside swatch
  const input = swatch.querySelector("input");
  if (!input) return;

  // Determine which type was clicked
  const clickedType = input.name; // "Color" or "Size"

  // Uncheck all in same group and check this one
  modal.querySelectorAll(`input[name="${clickedType}"]`).forEach((i) => {
    i.checked = false;
    i.closest(".variant-color-card, .variant-size-card")?.classList.remove(
      "active"
    );
  });
  input.checked = true;
  swatch.classList.add("active");

  // Collect currently checked options
  const selectedOptions = {};
  modal
    .querySelectorAll(
      ".variant-color-card input:checked, .variant-size-card input:checked"
    )
    .forEach((i) => {
      selectedOptions[i.name] = i.value;
    });

  // Try to find a variant matching both options
  let matchingVariant = product.find((v) => {
    return Object.entries(selectedOptions).every(([name, val]) => {
      return (
        v.option1?.toLowerCase() === val.toLowerCase() ||
        v.option2?.toLowerCase() === val.toLowerCase() ||
        v.option3?.toLowerCase() === val.toLowerCase()
      );
    });
  });

  // If no exact match, auto-select the other option
  if (!matchingVariant) {
    if (clickedType === "Size" && selectedOptions.Size) {
      // Size clicked → find first variant with this size
      const sizeVal = selectedOptions.Size.toLowerCase();
      matchingVariant = product.find(
        (v) =>
          v.option1?.toLowerCase() === sizeVal ||
          v.option2?.toLowerCase() === sizeVal ||
          v.option3?.toLowerCase() === sizeVal
      );

      if (matchingVariant) {
        const colorVal =
          matchingVariant.option1 ||
          matchingVariant.option2 ||
          matchingVariant.option3;
        modal.querySelectorAll(".variant-color-card input").forEach((i) => {
          const val = i.value.toLowerCase();
          if (val === colorVal.toLowerCase()) {
            i.checked = true;
            i.closest(".variant-color-card")?.classList.add("active");
          } else {
            i.checked = false;
            i.closest(".variant-color-card")?.classList.remove("active");
          }
        });
        selectedOptions.Color = colorVal;
      }
    } else if (clickedType === "Color" && selectedOptions.Color) {
      // Color clicked → find first variant with this color
      const colorVal = selectedOptions.Color.toLowerCase();
      matchingVariant = product.find(
        (v) =>
          v.option1?.toLowerCase() === colorVal ||
          v.option2?.toLowerCase() === colorVal ||
          v.option3?.toLowerCase() === colorVal
      );

      if (matchingVariant) {
        const sizeVal =
          matchingVariant.option1 ||
          matchingVariant.option2 ||
          matchingVariant.option3;
        modal.querySelectorAll(".variant-size-card input").forEach((i) => {
          const val = i.value.toLowerCase();
          if (val === sizeVal.toLowerCase()) {
            i.checked = true;
            i.closest(".variant-size-card")?.classList.add("active");
          } else {
            i.checked = false;
            i.closest(".variant-size-card")?.classList.remove("active");
          }
        });
        selectedOptions.Size = sizeVal;
      }
    }
  }

  if (!matchingVariant) {
    console.warn("⚠️ No matching variant found");
    return;
  }

  // Update hidden form input
  modal
    .querySelectorAll('form[action="/cart/add"] input[name="id"]')
    .forEach((i) => {
      i.value = matchingVariant.id;
    });

  // Update span labels
  const colorSpan = modal.querySelector("#selected__color");
  const sizeSpan = modal.querySelector("#selected__size");

  if (colorSpan && matchingVariant.option1)
    colorSpan.textContent = capitalizeEachWord(matchingVariant.option1);
  if (sizeSpan && matchingVariant.option2) {
    sizeSpan.textContent = capitalizeEachWord(matchingVariant.option2);
  } else if (sizeSpan && matchingVariant.option1) {
    sizeSpan.textContent = capitalizeEachWord(matchingVariant.option1);
  }

  // Update variant label
  const variantLabel = modal.querySelector(".selected__variant-label");
  if (variantLabel)
    variantLabel.textContent =
      matchingVariant.public_title || matchingVariant.title || "—";

  // Update main product image
  const mediaContainer = modal.querySelector(".product__media");
  if (mediaContainer && matchingVariant.featured_image) {
    const picture = mediaContainer.querySelector("picture");
    const img = picture?.querySelector("img");
    const sources = picture?.querySelectorAll("source") || [];
    const imageUrl =
      matchingVariant.featured_image.src || matchingVariant.featured_image;

    if (img) {
      img.src = imageUrl;
      img.alt = matchingVariant.title || "";
    }
    sources.forEach((source) => {
      source.srcset = imageUrl;
    });
  }

  const atcButton = modal.querySelector(
  '.product-form__submit, .atc_button, [type="submit"][name="add"]'
);

if (atcButton) {
  if (matchingVariant.available) {
    // Variant is in stock
    atcButton.disabled = false;
    atcButton.classList.remove("disabled", "opacity-50", "cursor-not-allowed");
    const span = atcButton.querySelector("span");
    if (span) span.textContent = "Add to cart";
  } else {
    // Variant is out of stock
    atcButton.disabled = true;
    atcButton.classList.add("disabled", "opacity-50", "cursor-not-allowed");
    const span = atcButton.querySelector("span");
    if (span) span.textContent = "Sold Out";
  }
}

  console.log("Selected options:", selectedOptions);
  console.log("✅ Modal variant updated:", matchingVariant.id, matchingVariant);
});
